YouTubeVideo = {
    resize: function(){
        setTimeout(function(){
            YouTubeVideo.doResize()
        }, 100)
    },

     doResize: function(){

        var videos = $('iframe[src^="https://www.youtube.com"]');
        videos.each(function(index, el) {
            var ratio = $(this).attr('width') / $(this).attr('height');
            var width = $(this).parent().outerWidth() - parseInt( $(this).parent().css("paddingLeft") ) - parseInt( $(this).parent().css("paddingRight") );
            var height =  Math.round(width) /  Math.round(ratio);
            $(this).width(width);
            $(this).height(height);
        });
    },
}
